module.exports = "https://portperrypedals.ca/_res/img/scugog.89e75c0.png";